<template>
  <div class="row mb-3">
    <div class="col col-md-9 col-lg-8 m-auto">
      <div class="d-flex align-items-center justify-content-between bulk-buy-banner rounded border shadow bg-white p-3">
        <b-button class="pl-0" variant="link" @click="bulk = !bulk">
          {{ $t('Cancel') }}
        </b-button>
        <div v-if="hasLeads" class="d-flex align-items-center">
          {{ $tc('{n}x Leads Selected', selectedLeadCount) }}
        </div>
        <b-button v-if="hasLeads" variant="primary" size="sm" @click="$emit('mobile-basket')">
          {{ $t('Buy') }}
        </b-button>
        <div v-else class="ml-3">
          <h3 class="h4 text-center">
            {{ $t('Bulk Buy Active') }}
          </h3>
          <span>{{ $t('Select the leads you would like to add to Bulk Buy by using the checkboxes available') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {BULK_BUY, SELECTED_LEADS} from "@/store/leads/mutation-types";

export default {
  name: "MobileBulkBanner",
  computed: {
    hasLeads: function() {
      return this.leads && this.leads.length > 0;
    },
    selectedLeadCount: function() {
      return this.leads.length;
    },
    leads: {
      get: function () {
        return this.$store.state.leads.SELECTED_LEADS;
      },
      set: function (value) {
        this.$store.commit(SELECTED_LEADS, value);
      }
    },
    bulk: {
      get: function () {
        return this.$store.state.leads.BULK_BUY;
      },
      set: function (value) {
        this.$store.commit(BULK_BUY, value);
      }
    },
  }
}
</script>

<style scoped lang="scss">

</style>
